import { useConfirmationDialog } from '@/shared/hooks';
import type { SavedPresetRecord } from '../../model/types';

interface Params {
  deletePreset: (id: string) => Promise<void>;
}

export function usePresetDeleteDialog({ deletePreset }: Params) {
  const { openDialog, dialogElememnt } = useConfirmationDialog({
    title: 'Delete preset',
    description: (context) => {
      const preset = context as SavedPresetRecord;
      return (
        <>
          Are you sure you want to delete "{preset?.name}"?
          <br />
          This action cannot be undone.
        </>
      );
    },
    acceptButtonText: 'Delete',
    acceptButtonColor: 'error',
    onAccept: (context) => {
      const preset = context as SavedPresetRecord;
      return deletePreset(preset.id);
    },
  });

  return {
    openDeleteDialog: (preset: SavedPresetRecord) => openDialog(preset),
    deleteDialogElement: dialogElememnt,
  };
}
